import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MemberComponent }   from '../member/member.component';
import { WebadminComponent }   from './webadmin.component';
import { MemberlistComponent }   from './memberList.component';
import { JourneyComponent }   from './journey.component';
import { ImportMemberComponent }   from './importMember.component';
import { AssignComponent }   from './assign.component';
import { SpritjoyComponent }   from './spritjoy.component';
import { MessageComponent }   from './message.component';

const routes: Routes = [
	{ 
		path: 'webadmin',
		component: WebadminComponent,
		children: [
			{
				path:'memberList',
				component: MemberlistComponent
			},
			{
				path:'journey',
				component: JourneyComponent
			},
			{
				path:'import',
				component: ImportMemberComponent
			},
			{
				path:'assign',
				component: AssignComponent
			},
			{
				path:'spritjoy',
				component: SpritjoyComponent
			},
			{
				path:'message',
				component: MessageComponent
			}

		]
	}
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class WebadminRoutingModule {}


/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/


// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/webadmin/webadmin-routing.module.ts